import { render, staticRenderFns } from "./ContactListSettingsView.vue?vue&type=template&id=e39e92d0"
import script from "./ContactListSettingsView.vue?vue&type=script&lang=js"
export * from "./ContactListSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports